import { Navigate, useLocation } from "react-router";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import { getUserProfile, UserProfile } from "../apis/apis";

interface PrivateRouteProps {
  children: React.ReactNode;
  roles?: string[]; // Roles permitidos
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, roles }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const location = useLocation(); // Obtiene la ubicación actual

  useEffect(() => {
    if (isAuthenticated) {
      getUserProfile()
        .then((profile) => {
          setUserProfile(profile);
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
        })
        .finally(() => {
          setIsProfileLoading(false);
        });
    } else {
      setIsProfileLoading(false);
    }
  }, [isAuthenticated]);

  console.log("Is authenticated in PrivateRoute:", isAuthenticated); // Traza
  console.log("Is loading in PrivateRoute:", isLoading); // Traza
  console.log("User profile in PrivateRoute:", userProfile); // Traza

  if (isLoading || isProfileLoading) {
    return <div>Loading...</div>; // Muestra un indicador de carga mientras se verifica la autenticación
  }

  if (!isAuthenticated) {
    console.log("Redirecting to /signin"); // Traza
    return <Navigate to="/signin" />;
  }

  if (roles && !roles.some((role) => user?.[role])) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
